import React from 'react'
import styled from 'styled-components'

import closeSrc from 'images/close_icon.png'

export function PointHow({ isOpened, onClose }) {
  return (
    <PointHowContainer isOpened={isOpened}>
      <PointHowHeader>
        <PointHowTitle>포인트 받는 방법</PointHowTitle>

        <CloseImgWrapper onClick={onClose}>
          <CloseImg src={closeSrc} />
        </CloseImgWrapper>
      </PointHowHeader>

      <PointHowBody>
        <PointHowDesc>챌린지 인증 : 랜덤 1~10P</PointHowDesc>
        <PointHowDesc>모티벨 퀴즈 : 랜덤 1~10P</PointHowDesc>
      </PointHowBody>
    </PointHowContainer>
  )
}

const PointHowContainer = styled.div`
  ${({ isOpened }) => (isOpened ? '' : 'display: none;')}
  position: absolute;
  left: calc(100vw * (22 / 375));
  top: 0;
  box-shadow: 0px 0px calc(100vw * (15 / 375)) #e6d8b1;
  border-radius: calc(100vw * (10 / 375));
  background-color: #ffffff;
  padding: 0 calc(100vw * (12 / 375));
  width: calc(100vw * (165 / 375));
  z-index: 3;
`

const PointHowHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: calc(100vw * (7 / 375));
`

const PointHowTitle = styled.div`
  font-weight: 600;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (23 / 375));
`

const CloseImgWrapper = styled.div`
  width: calc(100vw * (18 / 375));
  height: calc(100vw * (18 / 375));
  display: flex;
  justify-content: center;
  align-items: center;
`

const CloseImg = styled.img`
  width: calc(100vw * (9 / 375));
  height: calc(100vw * (9 / 375));
`

const PointHowBody = styled.div`
  margin-top: calc(100vw * (5 / 375));
  margin-bottom: calc(100vw * (10 / 375));
`

const PointHowDesc = styled.div`
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (23 / 375));
  color: #4e4e4e;
  word-break: keep-all;
  white-space: pre-wrap;
`
